import React from 'react';

import { SELECT_PLAN_SECTION_ID } from '@/constants';
import { scrollToById } from '@/utils/scrollToById';

import { OnboardingPaywallBtnGoPremium } from '../../components/BtnGoPremium';

import './GoPremium.scss';

export const OnboardingPaywallSectionGoPremium: React.FC = () => {
  const handleClick = () => {
    scrollToById(SELECT_PLAN_SECTION_ID);
  };

  return (
    <section className="go-premium">
      <OnboardingPaywallBtnGoPremium onClick={handleClick} type="button" />
    </section>
  );
};
